import*as o from"react";const t=o.createContext(void 0);"production"!==process.env.NODE_ENV&&(t.displayName="FormControlContext");var e=t;function r(){return o.useContext(e)}export{e as F,r as u};
